<div>
  <div class="bs-desc">{{"Enroll in paperless today to receive your bills and policies electronically while helping
    Mapfre
    attain its sustainability goals."}}</div>
  <div class="mb-4">
    <a href="https://www.mapfreinsurance.com/social-responsibility-policy" target="_blank" class="fs-16 mapfre link stuffer-underline red-link dm-sans-medium "> Learn more </a>
  </div>
  <div class="grey-color mb-4">
    Information from primary policyholder
    <mapfre-tooltip additionalClasses="tool-tip-w tooltip-position" [placementLocation]="'bottom'"
      [fullTitle]="'Where can I find my information?'"
      [description]="'Primary policyholder information, including policy number, can be found on the top left of either your last billing statement or renewal.'"
      autoCloseProp="false" [trigger]="'manual'" imgPath="assets/img/images/policy-holder-invoice-info.svg"
      [imageHasBody]="true">
    </mapfre-tooltip>
  </div>
  <form [formGroup]="paperlessEnrollForm" name="paperlessEnrollForm" (ngSubmit)="paperlessEnrollForm.valid && enroll()">
      <div class="">
          <div *ngFor="let input of inputs; index as index; " class="input">
              <mapfre-validation [input]="input" [form]="paperlessEnrollForm"></mapfre-validation>
          </div>
          <div class="bs-enroll-checkbox input">            
              <input class="single-checkbox" type="checkbox" id="paperless-legal-checkbox" required  (change)="isCheckBoxChecked($event)"  >
              <label for="paperless-legal-checkbox" class="grey-color" >I confirm that I have read and agree to the 
                <a href="https://www.mapfreinsurance.com/paperless-terms-conditions/" target="_blank" class="mapfre link stuffer-underline dm-sans-medium red-link font-weight-normal">{{"Terms & Conditions"}}                  
                </a> and <a href="https://www.mapfreinsurance.com/privacy-policy/" target="_blank" class="mapfre link stuffer-underline dm-sans-medium red-link font-weight-normal">Privacy Policy</a>.</label>
          </div>
      </div>
      <div class="bs-enroll-btns">
            <mapfre-button
              (click)="cancel()"
              additionalClasses="ghost secondary mr-4 bs-cancel" 
            >{{ 'CANCEL' | translate }}
          </mapfre-button>
          <mapfre-button
              [ngClass]="{ custom_loader: loader }"
              [disabledValue]="paperlessEnrollForm?.valid && isTermsAcccepted && !loader"
              additionalClasses="basic primary bs-enroll" 
              [disabledValue]="paperlessEnrollForm?.valid && !loader" 
              [inputType]="'submit'"
              [translateValue]="'Enroll' | translate"
            >
          </mapfre-button>
      </div>
  </form>
</div>
<app-confirm-modal *ngIf="showConfirmModal" (closeConfirmModal)="onCloseConfirmModal()"></app-confirm-modal>